export enum DocumentSegmentType {
  Income = 'Income',
  Expences = 'Expences',
  Other = 'Other',
  All = 'All',
  NotApplicable = 'NotApplicable',
}
